var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 516,
    viewBox: "0 0 431 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.617 503.08L280.616 503.08C221.951 519.335 158.169 512.71 106.545 488.599C54.8642 464.379 15.9649 422.773 6.52984 379.255L6.52902 379.251C1.78978 357.493 4.31191 334.913 9.14409 311.047C10.9117 302.317 13.0131 293.327 15.1564 284.159C18.7903 268.614 22.5446 252.553 24.9967 236.368C26.9649 223.376 28.1215 210.195 29.1459 197.116C29.3328 194.731 29.5151 192.351 29.6971 189.975C30.516 179.284 31.3272 168.694 32.5039 158.23C35.3789 132.666 40.394 108.344 52.6729 86.5619C77.3045 42.8672 131.708 8.54008 189.803 4.41555C247.863 0.348322 309.729 26.4694 347.896 68.262C386.026 110.015 400.808 167.594 413.41 227.891C426.037 288.356 435.899 348.892 414.346 398.302C392.819 447.652 339.481 486.786 280.617 503.08Z",
    stroke: "#DDEAE8",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.a56c88b1c471fb40f3c1a9f3fecdb4b2.svg";
export { ForwardRef as ReactComponent };